export default "__VITE_ASSET__BmnyfPLB__"